import React from 'react';

// Design System Components
import Tag from 'Components/DesignSystem/Tag/Tag';
import Typography from 'Components/DesignSystem/Typography/Typography';

// Constants
import { STRINGS, getApplication } from '../../constants';

// Types
import { ApplicationRef } from '../../types';

interface ApplicationBadgesProps {
  references: ApplicationRef[];
}

/**
 * The Referenced In cell: one colour-coded badge per referencing application, or
 * an em dash when nothing references the card (spec R18).
 *
 * Each badge carries the application's *name* as text, so the information does
 * not depend on telling blue from orange from green (NFR A1).
 */
const ApplicationBadges = ({ references }: ApplicationBadgesProps) => {
  if (references.length === 0) {
    // grey-600, not grey-500: this renders the "not referenced" em dash as body
    // text, and grey-500 measures 2.64:1 on white — well under the 4.5:1 WCAG
    // 2.2 AA needs for normal-size text. See styles/tokens.css.
    return (
      <Typography variant="body-primary" as="span" className="tw-text-ink-tertiary">
        {STRINGS.listing.noReferences}
      </Typography>
    );
  }

  return (
    <span className="tw-inline-flex tw-flex-wrap tw-items-center tw-gap-1">
      {references.map((reference) => {
        const application = getApplication(reference);
        return (
          <Tag key={application.id} label={application.label} tone={application.tone} showToneGlyph />
        );
      })}
    </span>
  );
};

export default ApplicationBadges;
